// src/App.jsx
import { useLocation } from "react-router-dom";
import AppRoutes from "./components/AppRoutes";
import AppShell from "./layout/AppShell";
import { useAuth } from "./context/AuthProvider";

export default function App() {
  const { user } = useAuth();
  const location = useLocation();

  const isPrint = location.pathname.startsWith("/print");

  if (isPrint) {
    // ⭐ Disable PWA mode so Edge/Chrome print the DOM instead of a PDF snapshot
    const manifest = document.querySelector('link[rel="manifest"]');
    if (manifest) {
      console.log("[PRINT] Removing manifest to disable PWA mode");
      manifest.remove();
    }

    // ⭐ Print page MUST NOT be wrapped in AppShell
    return <AppRoutes user={user} />;
  }

  // ⭐ Normal pages use AppShell
  return (
    <AppShell>
      <AppRoutes user={user} />
    </AppShell>
  );
}
